import PropTypes from 'prop-types';
import Humanize from 'humanize-plus';

import React, { Fragment, PureComponent } from 'react';
import styled from 'styled-components';

import { Row, FlexView, Separator, Text, Col } from '@cuemath/comps';

const UniformCol = styled(Col)`
  flex: 1;
  border-left: ${({ borderLeft }) => borderLeft};
`;

const TableWrapper = styled.div`
  border: 1px solid #eeeeee;
  margin: 16px;
`;

export default class TableModal extends PureComponent {
  static propTypes = {
    tableData: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    keyName: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    title: PropTypes.string.isRequired,
    suffixKeys: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    tableKeys: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  };

  render() {
    const { tableData, title, tableKeys, suffixKeys, keyName } = this.props;

    return (
      <FlexView gap={16} gutter>
        <Text align="center" weight="bold" gap>
          {' '}
          {title}{' '}
        </Text>
        <TableWrapper>
          {tableKeys.map((key, index) => (
            <Fragment key={index}>
              <Row alignItems="stretch" gutter>
                <UniformCol gap={8}>
                  {Humanize.capitalize(keyName && keyName[key] ? keyName[key] : key)}
                </UniformCol>
                <UniformCol borderLeft="1px solid #EEEEEE" gap={8}>
                  <Text>
                    {tableData[key] && tableData[key].toString()}{' '}
                    {suffixKeys && suffixKeys[key] ? ` ${suffixKeys[key]}` : null}
                  </Text>
                </UniformCol>
              </Row>
              {index !== tableKeys.length - 1 ? <Separator /> : null}
            </Fragment>
          ))}
        </TableWrapper>
      </FlexView>
    );
  }
}
